module.exports = __webpack_public_path__ + "img/short.365f76f3.svg";